/**
 * Configuration for account-based destination filtering in trade widgets.
 *
 * When an account's ID matches one of the configured IDs,
 * only the specified destination(s) will be available.
 */

export interface DestinationFilterRule {
    /** Account IDs that trigger this filter */
    accountIds: readonly string[];
    /** Destination(s) to allow when filter matches */
    allowedDestinations: readonly string[];
}

/**
 * Central configuration for account-based destination filtering.
 * Add entries here to restrict destinations for specific accounts.
 */
export const DESTINATION_FILTER_RULES: readonly DestinationFilterRule[] = [
    {
        accountIds: [
            '8735c22d-4f37-49bb-a447-dba81e0da591', // AVTR001
            '7518f62d-c8a7-4e2c-b051-3347a23dedf5', // AVTR016
            '40a89a09-0d1e-42a2-b2bf-3b83a219d912', // AVTR016_OUTGOING
            'bd169cf4-e6de-484e-bfff-cb3c88958f78', // AVTR016_O
        ],
        allowedDestinations: ['DAS'],
    },
];
